import React from 'react';
import { Gift, Download, Check } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Manual de Entrenamiento Mental en Casa',
    img: 'https://cdn.magicpatterns.com/uploads/1jpgCMXCwdTZkEkqCb6ZEU/BONO1.png',
    desc: 'Ejercicios prácticos antes y después de partidos.'
  }, {
    title: 'Guía Estratégica Competitiva',
    img: 'https://cdn.magicpatterns.com/uploads/o3v4zcQSwscECf29FMX2D1/BONO_2_(4).png',
    desc: 'Cómo interactuar correctamente con entrenadores y clubes.'
  }, {
    title: 'Sistema de Prevención del Abandono',
    img: 'https://cdn.magicpatterns.com/uploads/pyamoXWwn9zUK8gBJevCcG/BOBO_3.png',
    desc: 'Señales tempranas y protocolos de intervención.'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <span className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4 inline-block" data-id="element-4">
            Incluidos sin costo
          </span>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 uppercase mb-4" data-id="element-5">
            🎁 BONOS INCLUIDOS MAS WORKBOOK IMPRIMIBLE SIN COSTO
          </h2>
          <p className="text-xl md:text-2xl font-bold text-red-600" data-id="element-6">
            Bonos valuados en $15.990 —{' '}
            <span className="underline decoration-4 decoration-yellow-400" data-id="element-7">
              Incluidos sin costo en esta edición
            </span>
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-8">
          {bonuses.map((bonus, i) => <div key={i} className="flex flex-col items-center group" data-id="element-9">
              <div className="relative mb-6" data-id="element-10">
                <div className="absolute inset-0 bg-blue-900 rounded-xl rotate-3 group-hover:rotate-6 transition duration-300 opacity-20" data-id="element-11"></div>
                <img src={bonus.img} alt={bonus.title} className="relative w-full max-w-[280px] mx-auto drop-shadow-xl rounded-lg transform group-hover:-translate-y-2 transition duration-300" data-id="element-12" />
              </div>
              <div className="flex items-start gap-2 mb-2 max-w-xs" data-id="element-13">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-14" />
                <h3 className="font-bold text-lg text-gray-900" data-id="element-15">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-center text-gray-600 text-sm" data-id="element-16">{bonus.desc}</p>
            </div>)}
        </div>

        {/* Workbook Section */}
        <div className="bg-gray-900 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-17">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-600 rounded-full blur-3xl opacity-20 -mr-32 -mt-32" data-id="element-18"></div>

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-19">
            <div data-id="element-20">
              <div className="inline-flex items-center gap-2 bg-green-600/20 text-green-400 px-3 py-1 rounded-full text-sm font-bold mb-4 border border-green-600/30" data-id="element-21">
                <Gift className="w-4 h-4" data-id="element-22" />
                WORKBOOK OFICIAL
              </div>
              <h3 className="text-3xl md:text-4xl font-black mb-6" data-id="element-23">
                📘 WORKBOOK IMPRIMIBLE
              </h3>
              <ul className="space-y-3 mb-8" data-id="element-24">
                {['Checklists', 'Protocolos', 'Ejercicios guiados', 'Planes de acción', 'Plantillas aplicables'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-25">
                    <div className="bg-green-500 rounded-full p-1" data-id="element-26">
                      <CheckIcon className="w-3 h-3 text-white" data-id="element-27" />
                    </div>
                    <span className="text-lg text-gray-200" data-id="element-28">{item}</span>
                  </li>)}
              </ul>
              <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 px-6 py-3 rounded-lg" data-id="element-29">
                <p className="font-bold text-green-400 flex items-center gap-2" data-id="element-30">
                  <Download className="w-5 h-5" data-id="element-31" />
                  Aplicación inmediata en el entorno familiar
                </p>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/vTeCp1fazDc19AqFG7Sd4D/WORBOOK.png" alt="Workbook Imprimible" className="w-full max-w-sm drop-shadow-2xl transform rotate-3 hover:rotate-0 transition duration-500" data-id="element-33" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function CheckIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-34">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-35" />
    </svg>;
}